import { useFormContext } from "react-hook-form";

export const useFullNameInput = () => {
  const { control } = useFormContext();
  return { control };
};
